import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "contact-card__icon" }
const _hoisted_2 = { class: "contact-card__label" }
const _hoisted_3 = { class: "contact-card__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: "2000",
      color: "secondary"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackbarText), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_row, { justify: "center" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (c, i) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            key: i,
            cols: "12",
            sm: "6",
            lg: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "hk-card hk-card--hover contact-card pa-6 h-100",
                href: c.href,
                target: c.external ? '_blank' : undefined,
                onClick: ($event: any) => (_ctx.onContactClick(c))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_icon, {
                      icon: c.icon,
                      size: "34"
                    }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("div", _hoisted_2, _toDisplayString(c.label), 1),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(c.value), 1),
                  (c.copy)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "mt-3",
                        size: "small",
                        variant: "tonal",
                        color: "secondary",
                        "prepend-icon": "mdi-content-copy",
                        onClick: _withModifiers(($event: any) => (_ctx.addToClipboard(c.copy, c.conversion)), ["prevent","stop"])
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode(" Másolás ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["href", "target", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}